<template>
  <nav
    v-on-clickaway="away"
    :class="open ? 'open' : 'closed'"
    class="align-right settings-nav">
    <a
      href="#settingsNav"
      class="avatar font-size-1 bold"
      @click.prevent="open =! open"><svg-menu :class="'menu-icon'" /><img
        v-if="user.avatar"
        :src="user.avatar"
        alt="avatar"
        class="avatar-image"><svg-avatar
          v-else
          :class="'avatar-image'" /></a>
    <div
      id="settingsNav"
      class="reverse reverse align-left drop">
      <div class="links px05 pt05">
        <router-link
          :to="{ name: 'settings' }"
          active-class="active"
          @click.native="open = false"><svg-settings/> Settings</router-link>
        <router-link
          :to="{ name: 'members' }"
          active-class="active"
          @click.native="open = false"><svg-people/> Members</router-link>
        <hr class="black-border mx1 my0">
        <router-link
          :to="{ name: 'organizationSwitch' }"
          active-class="active"
          @click.native="open = false"><svg-switch/> Switch organization</router-link>
        <hr class="black-border mx1 my0">
        <a
          href="/"
          @click.prevent="signOut"><svg-out/> Sign out</a>
      </div>
    </div>
  </nav>
</template>

<script>
import * as firebase from 'firebase'
import { mixin as clickaway } from 'vue-clickaway'
import { mapGetters } from 'vuex'
import Avatar from '../svgs/Avatar.vue'
import Settings from '../svgs/Settings'
import Switch from '../svgs/Switch'
import People from '../svgs/People'
import Out from '../svgs/Out'
import Menu from '../svgs/Menu'

export default {
  components: {
    svgAvatar: Avatar,
    svgSettings: Settings,
    svgPeople: People,
    svgSwitch: Switch,
    svgOut: Out,
    svgMenu: Menu
  },
  mixins: [ clickaway ],
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization'
    ])
  },
  methods: {
    signOut () {
      this.user.selectedOrganization = false
      firebase.default.auth().signOut().then(response => {
        this.user = null
      }).catch(error => console.log(error))
    },
    away () {
      this.open = false
    }
  }
}
</script>

<style scoped>
  nav {
    position: absolute;
    right: var(--page-margin);
    top: calc(var(--line) * 0.5);
  }
  .drop {
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.4);
    margin-top: calc(var(--line) * -0.2);
    max-height: 0;
    overflow: hidden;
  }
  .drop a {
    font-size: var(--font-size-2);
    display: block;
    padding: calc(var(--line) * 0.8) var(--line);
    text-decoration: none;
    font-weight: var(--regular);
    font-family: var(--sans);
    letter-spacing: 0.0333em;
  }
  .links svg {
    width: 1.1em;
    height: 1.1em;
    vertical-align: top;
    margin-top: 2px;
    margin-right: 0.5em;
  }
  .links svg {
    fill: var(--white);
  }
  .links a.active {
    color: var(--accent);
    cursor: default;
  }
  .links a.active svg {
    color: var(--accent);
    fill: var(--accent);
  }
  .drop a:hover,
  .drop a:active,
  .drop a:focus {
    color: var(--accent);
  }
  .links {
    transform: translateY(-25%);
  }
  .drop,
  .links {
    transition: 0.15s all cubic-bezier(.48,.63,.31,1.10);
  }
  .avatar {
    background-color: rgba(0,0,0,0.01);
    padding: 3px 3px 1px 3px;
    display: inline-block;
    border-radius: var(--radius);
  }
  .avatar:hover {
    background-color: var(--grey-250);
  }
  .avatar img,
  .avatar svg {
    display: inline-block;
    border-radius: var(--tight-radius);
    width: calc(var(--line) * 1.5);
    height: calc(var(--line) * 1.5);
  }
  .avatar svg:first-child {
    margin: calc(var(--line) * .25) calc(var(--line) * .25) calc(var(--line) * .25) calc((var(--line) * .25) - 3px);
    width: calc(var(--line) * .25);
    height: calc(var(--line) * 1);
    fill: var(--dark-grey);
    transition: fill 0.2s ease;
  }
  .avatar:hover svg:first-child {
    fill: var(--accent);
  }
  .settings-nav {
    z-index: 0;
  }
  .open {
    z-index: 100;
  }
  .open .avatar,
  .open .avatar img,
  .open .avatar svg {
    background-color: var(--dark-grey);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .open .avatar svg:first-child {
    fill: var(--accent);
  }
  .open .drop {
    max-height: calc(var(--line) * 18);
  }
  .open .links {
    transform: translateY(0%);
  }
  .open .drop,
  .open .links {
    transition: 0.15s all cubic-bezier(.48,.63,.31,1.10);
  }
  @media screen and (min-width: 48em) {
    nav {
      top: calc(var(--line) * 0.75);
    }
  }
</style>
